import {
	getTableItems,
	TABLE_GROUP,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/table';
import { getStickyHeaderScrollTop } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/visualisations';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import { SCOPE_ROW_HEIGHT } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';

export type TableItemGeometry = {
	index: number;
	height: number;
	offset: number;
};

/**
 * Scan scope for group headers and return their geometry (height and top offset in pixels).
 */
export const getGroupHeadersGeometry = createSelector(
	[getTableItems],
	(scope) =>
		scope.reduce<{
			offset: number;
			headers: Array<{ index: number; height: number; offset: number }>;
		}>(
			(acc, { tag, height = 1 }, index) => {
				const pixelHeight = height * SCOPE_ROW_HEIGHT;
				if (tag === TABLE_GROUP) {
					acc.headers.push({ index, height: pixelHeight, offset: acc.offset });
				}
				acc.offset += pixelHeight;
				return acc;
			},
			{ headers: [], offset: 0 },
		).headers,
);

/**
 * Get current sticky header geometry based on table scroll position.
 * Return null if there is no group headers or the next header overlaps with the sticky one,
 * because we don't want to show the sticky header in that case.
 */
export const getCurrentStickyHeaderGeometry = createSelector(
	[getGroupHeadersGeometry, getStickyHeaderScrollTop],
	(headers, scrollTop) => {
		if (headers.length === 0 || scrollTop === 0) return null;
		for (let i = 1; i < headers.length; i++) {
			const currentHeader = headers[i - 1];
			const nextHeader = headers[i];
			if (nextHeader.offset > scrollTop) {
				return nextHeader.offset > scrollTop + currentHeader.height ? currentHeader : null;
			}
		}
		return headers[headers.length - 1];
	},
);
